import React, { useContext } from "react";

import { Table, Thead, Tbody, Tr, Th } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { UserContext } from "../../contexts";
import { InfiniteScroll } from "../../components";

const defaultFetchParams = {
  sort: {
    field: "created_at",
    direction: "desc",
  },
};

const AlertListingTable = ({
  className = "",
  emptyText = "No results found.",

  data = [],
  fetchUrl,
  fetchParams,
  fetchLimit = 5,

  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  responsive = true,
  headers,
  RowComponent,
  onSelectClick,
  onResultsLoaded,
  height,
  firstPageOnly = false,
  rowComponentProps = {},
  scrollableTarget,
}) => {
  const { user } = useContext(UserContext);

  fetchParams = { ...defaultFetchParams, ...(fetchParams || {}) };

  const table = (headers, items) => {
    const body = items.map((item) => (
      <RowComponent
        item={item}
        key={item.listing_id}
        headers={headers}
        onSelectClick={onSelectClick ? () => onSelectClick(item) : null}
        {...rowComponentProps}
      />
    ));

    return (
      <Table className={className}>
        <Thead>
          <Tr>
            {headers.map((content, i) => (
              <Th key={i}>{content}</Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>{body}</Tbody>
      </Table>
    );
  };

  return (
    <InfiniteScroll
      data={data}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      fetchUrl={fetchUrl}
      fetchParams={fetchParams}
      fetchLimit={fetchLimit}
      height={height}
      responsive={responsive}
      firstPageOnly={firstPageOnly}
      scrollableTarget={scrollableTarget}
      onResultsLoaded={onResultsLoaded}
    >
      {({ items, isLoading }) => {
        return (
          <>
            {items.length > 0 && table(headers, items)}

            {!isLoading && items.length === 0 && (
              <div className="no-results">
                <p>{emptyText}</p>
              </div>
            )}
          </>
        );
      }}
    </InfiniteScroll>
  );
};

export default AlertListingTable;
